// 对局观测 · 导演：场外偏好、偏好哈希（浏览器 SHA-256，观测推导里唯一的异步函数）与导演状态。

import { asArray, latestRecords } from './run-records.js'

/** 仍然生效的场外偏好：每种只取最新一条，值为空或已过期的不算。 */
export function activePreferences(branch) {
  const turn_count = asArray(branch.turns).length
  return latestRecords(asArray(branch.preferences), (item) => item.kind)
    .filter((item) => item.value && (item.expires_seq === null || item.expires_seq > turn_count))
    .sort((a, b) => (a.revision || 0) - (b.revision || 0))
}

/** 引擎 director_preference_hash：分支偏好数组 JSON 的 SHA-256。快照经 JSON 原样传到浏览器，键序与服务端一致。 */
export async function preferenceHash(branch) {
  const bytes = new TextEncoder().encode(JSON.stringify(branch.preferences || []))
  const digest = await globalThis.crypto.subtle.digest('SHA-256', bytes)
  return [...new Uint8Array(digest)].map((byte) => byte.toString(16).padStart(2, '0')).join('')
}

function directorConfig(snapshot) {
  const director = snapshot.director
  const valid = director && typeof director.enabled === 'boolean' && Number.isSafeInteger(director.revision) && director.revision >= 0
  return valid ? director : { enabled: false, revision: 0 }
}

/**
 * 导演开关、当前状态与最新建议，与服务端 directorView、引擎 select_director_guidance 同一套判断：
 * 建议只在开关开着、修订号与偏好哈希都对得上、当前轮次落在生效区间内时可用。
 * 没有叙事设定的作品没有导演（返回 null）；开关开着但偏好哈希还没算出或算不出时 status 为 null，建议是否可用无从判断。
 */
export function directorState(snapshot, pack, branch, preference_hash) {
  if (!pack.narrative) return null
  const director = directorConfig(snapshot)
  const stored = branch.director_guidance ?? null
  if (!director.enabled) return { enabled: false, revision: director.revision, status: 'disabled', guidance: stored }
  if (preference_hash === null) return { enabled: true, revision: director.revision, status: null, guidance: stored }
  const turn_count = asArray(branch.turns).length
  const matches = Boolean(stored && stored.director_revision === director.revision && stored.preference_hash === preference_hash)
  const selected = matches && turn_count >= stored.based_on_through_seq && turn_count < stored.valid_through_seq
  const pending = asArray(branch.jobs).some((job) => job.kind === 'director' && job.status === 'pending' && job.director_revision === director.revision)
  return {
    enabled: true,
    revision: director.revision,
    status: selected ? 'ready' : pending ? 'pending' : 'unavailable',
    guidance: matches ? { ...stored, direction_status: selected ? 'available' : 'expired' } : stored,
  }
}
